<template>
  <div class="content">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
  export default {
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/Content.vue